import { useProfitQuery } from '@client/mainClient/collections/ProfitClientAction'
import { ProfitFilterParams } from '@models/Profit/ProfitFilterParams'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { BotMarketType } from '@interfaces/BotMarketEnum'
import { ProfitType } from '@models/Profit/ProfitType'
import { TotalProfitAcceptProps, TotalProfitProps } from './interface'

const withTotalProfit = (Component: React.FC<TotalProfitProps>) => {
  const Hoc = ({ className }: TotalProfitAcceptProps) => {
    const [profitParams, setProfitParams] = useState<{
      today: ProfitFilterParams
      thisMonth: ProfitFilterParams
    }>()

    const { data: profitToday } = useProfitQuery(
      { profitType: ProfitType.DAILY, botMarketType: BotMarketType.FUTURE },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )
    const { data: profitThisMonth } = useProfitQuery(
      { profitType: ProfitType.MONTHLY, botMarketType: BotMarketType.FUTURE },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )
    const { data: profitAll } = useProfitQuery(
      { profitType: ProfitType.ALL_TIME, botMarketType: BotMarketType.FUTURE },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )

    const { data: profitTodaySpot } = useProfitQuery(
      { profitType: ProfitType.DAILY, botMarketType: BotMarketType.SPOT },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )
    const { data: profitThisMonthSpot } = useProfitQuery(
      { profitType: ProfitType.MONTHLY, botMarketType: BotMarketType.SPOT },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )
    const { data: profitAllSpot } = useProfitQuery(
      { profitType: ProfitType.ALL_TIME, botMarketType: BotMarketType.SPOT },
      {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
      }
    )

    const newProps: TotalProfitProps = {
      contractProfit: {
        today: profitToday?.profitUsd || 0,
        month: profitThisMonth?.profitUsd || 0,
        total: profitAll?.profitUsd || 0,
      },
      spotProfit: {
        today: profitTodaySpot?.profitUsd || 0,
        month: profitThisMonthSpot?.profitUsd || 0,
        total: profitAllSpot?.profitUsd || 0,
      },

      className,
    }
    return <Component {...newProps} />
  }
  return Hoc
}

export default withTotalProfit
